import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import RPCLog from '../views/RPCLog.vue';
import Menu from '../views/Menu.vue';
import ARManualPlacement from '../views/ARManualPlacement.vue';
import ARImageTracking from '../views/ARImageTracking.vue';
import UnityScene from '../views/UnityScene.vue';
import UnlockCode from '../views/UnlockCode.vue';
import VirtualPlayer from '../views/VirtualPlayer.vue';

Vue.use(VueRouter);

// the home path (/) is set by the environment variable 'VUE_APP_HOME'

function homeComponent() {
  const home = process.env.VUE_APP_HOME || 'home';

  switch (home) {
    case 'empty':
      return { component: undefined };

    case 'home':
      return { component: () => import('../views/Home.vue') };

    case 'quiz':
      return {
        component: () => import('../prototyping/quiz/Container.vue'),
      };

    case 'input':
      return {
        component: () => import('../views/Input.vue'),
      };

    case 'hammer':
      return {
        component: () => import('../views/HammerJsInput.vue'),
      };

    case 'proofofconcept':
    default:
      return { component: () => import('../views/ProofOfConcept.vue') };
  }
}

const routes = [
  {
    path: '/',
    name: 'Home',
    ...homeComponent(),
    children: [
      {
        path: '',
        name: 'Record Player',
        component: () => import('../views/Player.vue'),
      },
      {
        path: 'track-info/*',
        name: 'Artist / song info',
        component: () => import('../views/Storyblok.vue'),
      },
      {
        path: 'library',
        name: 'My Collection',
        component: () => import('../views/Library.vue'),
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('../views/Storyblok.vue'),
      },
      {
        path: '/virtual-player',
        name: 'Virtual player',
        component: VirtualPlayer,
        props: true,
      },
      {
        path: '/unlock-code',
        name: 'Unlock Vinylpostcard',
        component: UnlockCode,
      },
    ],
  },
  {
    path: '/audio-tracks',
    name: 'Audio Tracks',
    component: () => import('../views/Storyblok.vue'),
    props: { editorOnly: true },
  },
  {
    path: '/menu',
    name: 'Menu',
    component: Menu,
  },
  {
    path: '/arimagetracking',
    name: 'ARImageTracking',
    component: ARImageTracking,
  },
  {
    path: '/armanualplacement',
    name: 'ARManualPlacement',
    component: ARManualPlacement,
    props: true,
  },
  {
    path: '/rpclog',
    name: 'RPC Log',
    component: RPCLog,
  },
  {
    path: '/proofofconcept',
    name: 'ProofOfConcept',
    component: () => import('../views/ProofOfConcept.vue'),
  },
  {
    path: '/unityscene',
    name: 'UnityScene',
    component: UnityScene,
    props: (route: Route) => ({ scene: route.query.scene }),
  },
];

const router = new VueRouter({
  mode: process.env.VUE_APP_BUILD_OFFLINE ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
